import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { addWorkerAction, getAllWorkers, setAddWorkerResponse, setAllWorkers, updateWorkerResponse, updateWorkersAction } from "../reducers/workerSlice";


/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllWorkersSaga(): any {
    yield put(setLoaderAction(true))
    console.log('plans-try')
    try {
       
        const res = yield call<any>(callAPI, {}, 'get', `client/workers`)
        console.log('plans-', res)
        if (res?.data) {
            yield put(setAllWorkers(res?.data))
        }
    } catch (error) {
        console.log('Catch Error-', error)
    }
    yield put(setLoaderAction(false))
}

function* addWorkerSaga(payload: any[]):any {
    yield put(setLoaderAction(true))
    yield put(setNotificationAction({message: [], severity: 'error'}))
    try {
        const apiResponse = yield call<any>(callAPI, payload, 'post', 'client/workers')
        console.log('changePassword-', apiResponse)
        if (apiResponse?.success === true) {
            apiResponse && handleSuccess(apiResponse);
            yield put(setAddWorkerResponse(true));
            yield put(setNotificationAction({message: [], severity: 'error'}))
        }
    } catch (error: any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setAddWorkerResponse(false));

    }
    yield put(setLoaderAction(false))
}

function* updateWorkersSaga(payload: { payload: any }):any {
    yield put(setLoaderAction(true))
    yield put(setNotificationAction({message: [], severity: 'error'}))
    try {
        // const {id} = payload;
        console.log("payload", payload);
        const {id, ...newPayload} = payload?.payload;
        const apiResponse = yield call<any>(callAPI, {payload:newPayload}, 'put', `client/workers/${id}`)
        console.log('changePassword-', apiResponse)
        if (apiResponse?.success === true) {
            apiResponse && handleSuccess(apiResponse);
            yield put(updateWorkerResponse(true));
            yield put(setNotificationAction({message: [], severity: 'error'}))
        }
    } catch (error: any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(updateWorkerResponse(false));

    }
    yield put(setLoaderAction(false))
}


export function* watchWorker() {
    yield takeLatest<any>(getAllWorkers, getAllWorkersSaga);
    yield takeLatest<any>(addWorkerAction, addWorkerSaga);
    yield takeLatest<any>(updateWorkersAction, updateWorkersSaga);

}